// test1047
(1047 && 0);
